// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSingleStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.99 10.027a.35.35 0 0 1-.087.163l-4.214 4.316.995 6.106a.36.36 0 0 1-.021.187.34.34 0 0 1-.112.148.3.3 0 0 1-.186.04.3.3 0 0 1-.153-.04l-5.176-2.866-5.239 2.876a.31.31 0 0 1-.347-.021.34.34 0 0 1-.112-.15.36.36 0 0 1-.017-.19l.995-6.09-4.22-4.316a.362.362 0 0 1-.081-.35.35.35 0 0 1 .102-.153.33.33 0 0 1 .16-.077l5.83-.89 2.605-5.547a.35.35 0 0 1 .123-.127.33.33 0 0 1 .335 0c.05.03.093.075.123.127l2.605 5.546 5.824.89q.091.016.162.077a.35.35 0 0 1 .107.34"
    />
  </svg>
);
export default SvgSingleStar;
